import {Component, computed, Input, OnChanges, signal, SimpleChanges, ViewChild} from '@angular/core';
import {User, RestClient} from '../../../../Api/DcoApi/Client/RestClient'
import {Report} from '../../../../Api/DcoApi/Reporting/Report';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CommonModule} from '@angular/common';
import {ReportDesigner} from '../../report-designer/report-designer';
import {DataGridView, DataGridViewCollumn} from '../../../../Componente/DataGridView';
import {PopUpView} from '../../../../Componente/PopUpView';
import {GeraeteModell} from '../../../../Api/DcoApi/Admin/AdminClasses2';
import {RouteEdit} from '../route-edit/route-edit';

@Component({
  selector: 'report-admin-edit',
  imports: [
    ReactiveFormsModule, CommonModule, FormsModule, ReportDesigner, DataGridView, DataGridViewCollumn, PopUpView, RouteEdit
  ],
  templateUrl: './report-admin-edit.html',
  styleUrl: './report-admin-edit.css',
})
export class ReportAdminEdit implements OnChanges {

  @Input() Report:Report = { key: 0, createdAt: new Date(), updatedAt: new Date(), bezeichnung: '' } as Report;
  @ViewChild('Grid') childComponent!: DataGridView<GeraeteModell>;
  @ViewChild('Editor') Editor!: ReportDesigner
  IsNew =signal(this.Report.key === 0);
  ApiClient: RestClient = new RestClient();

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['Report']) {
      this.IsNew.set(this.Report.key === 0);

    }

  }

  triggerReload() {
    // Call the child component's function safely
    this.childComponent.LoadData();
  }

  async SaveData() {
    if(this.IsNew())
      this.Report = await this.ApiClient.Put<Report,Report>(`/Backend/Api/V2/ReportAdmin`, this.Report);
    else {
      this.Report = await this.ApiClient.Post<Report, Report>(`/Backend/Api/V2/ReportAdmin/${this.Report.key}`, this.Report);
      this.Editor.Save();
    }

    this.IsNew.set(this.Report.key === 0);
  }
}
